import React from "react";
import { Link } from "react-router-dom";
import { Play, ArrowRight } from "lucide-react";
import { YCN_HERO_VIDEO } from "@/data/constants";
import WatchNowButton from "@/components/watch/WatchNowButton";

export default function HeroCarousel() {
  return (
    <div
      data-testid="hero-carousel"
      className="relative w-full h-[78vh] min-h-[560px] md:h-[86vh] overflow-hidden"
    >
      {/* YCN brand video background */}
      <video
        data-testid="hero-brand-video"
        src={YCN_HERO_VIDEO}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 ycn-hero-vignette pointer-events-none" />

      {/* Brand content */}
      <div className="absolute inset-0 flex items-end md:items-center">
        <div className="max-w-[1600px] w-full mx-auto px-6 md:px-12 pb-16 md:pb-0">
          <div className="max-w-2xl ycn-fade-up">
            <div className="mb-4 inline-flex items-center gap-2 px-3 py-1 rounded-full ycn-glass text-[11px] uppercase tracking-[0.35em] text-white/80">
              <span className="ycn-gradient-text font-bold">Your Channel Network</span>
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-black leading-[0.95] tracking-tight text-white uppercase drop-shadow-[0_4px_30px_rgba(0,0,0,0.6)]">
              Your Story. <br />
              Your Voice. <br />
              <span className="ycn-gradient-text">Your Channel.</span>
            </h1>
            <p className="mt-6 text-white/85 text-base md:text-lg max-w-lg leading-relaxed">
              A global, independently owned streaming network for movies, original series, documentaries, comedy, lifestyle and more.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <WatchNowButton
                testId="hero-watch-btn"
                label="Watch Now"
                className="!px-7 !py-3 text-base"
              />
              <Link
                to="/about"
                data-testid="hero-info-btn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full ycn-glass hover:bg-white/15 font-semibold text-white transition"
              >
                About YCN <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
